
<tr
    :class="{
        selected: isSelected,
        clickable: isClickable,
        checked: selectable && isChecked,
        expanded: expanded,
        'parent-row': hasChildren,
        'child-row': item._isChild,
        'search-match': isSearchMatch,
        'gap-row': item._isGap,
        'row-even': isEvenRow,
        'disabled-row': isDisabled,
        'has-gps-data': item.hasGpsData,
        'has-border':
            !!borderColor && (Array.isArray(borderColor) ? borderColor.length > 0 : true),
    }"
    :style="{
        '--indent-level': item._level || 0,
        ...borderStyles,
    }"
    :data-border-count="borderCount"
    :id="item._id"
    @click="handleRowClick($event)"
    v-on="!isMobile ? { mouseenter: handleRowHover, mouseleave: handleRowLeave } : {}"
>
    <td
        v-if="showCounter"
        class="counter-column text-center"
        :class="{
            indented: item._isChild,
        }"
    >
        {{ index }}
    </td>
    <td
        v-for="(column, colIndex) in columns"
        :key="colIndex"
        :data-priority="column.priority || 1"
        :class="[
            column.align ? `text-${column.align}` : '',
            { 'first-column': colIndex === 0 },
            { indented: colIndex === 0 && item._isChild },
        ]"
        :style="getColumnStyle(column)"
        v-tooltip="getColumnTooltip(column)"
    >
        <template v-if="colIndex === 0 && !item._isGap">
            <span
                v-if="hasChildren || hasAnyExpandableRows"
                :class="[
                    hasChildren ? 'expand-toggle' : 'expand-toggle-spacer',
                    { 'is-expanded': expanded },
                ]"
                @click.stop="hasChildren && toggleExpand()"
            >
                <i v-if="hasChildren" :class="'ri-arrow-right-s-line'"></i>
            </span>
        </template>

        <template v-if="column.component">
            <component
                :is="resolveComponent(column.component)"
                v-bind="getComponentProps(column)"
                @input="handleComponentInput($event, column)"
            />
        </template>
        <template v-else>
            <slot
                :name="`column-${column.key}`"
                :item="item"
                :value="getItemValue(column)"
                :column="column"
            >
                <span>{{ truncateText(getItemValue(column), cellTruncateLength) }}</span>
            </slot>
        </template>
    </td>

    <td v-if="selectable" class="checkbox-column">
        <label class="checkbox-wrapper">
            <input
                type="checkbox"
                class="checkbox-input"
                :checked="isChecked"
                @change="toggleItemChecked"
                @click.stop
            />
            <span class="checkmark" v-if="isChecked">
                <i class="ri-check-line"></i>
            </span>
        </label>
    </td>
</tr>
